export default __webpack_public_path__ + "static/media/follow.b0bc4d1b.png";